<!--
 * @Description: 国安单个样品通用组件
 * @Author: zml
 * @Date: 2023-07-21 16:47:57
 * @LastEditors: zml
 * @LastEditTime: 2025-08-29 15:09:40
-->
<template>
  <div class="item">
    <div :class="`img-box ${types=='big'?'bigsamll':''}`" @click="gotoDetail(productData.co_Nu)">
      <img :src="productData.imgUrl" :alt="productData.co_Nu" srcset />
    </div>
    <div class="item-info">
      <div class="preices-serchart">
        <div class="price">
          <span v-if="userInfo.id">{{ userInfo.symbol }}{{ productData.price }}</span>
          <span @click="login()" v-else>****</span>
        </div>
        <img src="../../assets/fangdajin.png" alt @click="fangdajin(productData)" />
      </div>
      <div class="title">{{ $hs(productData.pr_Na,productData.pr_En_Na,productData.basicThreeLanguage) }}</div>
      <div class="num">{{ productData.co_Nu }}</div>
      <div
        :class="`price-cart ${markCart(productData.co_Nu) ? 'price-cart-Active':''}`"
        @click="handleToCart(productData)"
        v-if="userInfo.id"
      >
        <i class="el-icon-check" style="color: orange;" v-if="markCart(productData.co_Nu)"></i>
        <i class="el-icon-shopping-cart-2" v-else></i>
        <span>{{ $hs('添加购物车','Add To Cart','Añadir al carrito') }}</span>
      </div>
      <div class="price-cart" @click="login()" v-else>
        <i class="el-icon-shopping-cart-2"></i>
        <span>{{ $hs('添加购物车','Add To Cart','Añadir al carrito') }}</span>
      </div>
    </div>
    <login-modal ref="loginModal" @register="register"></login-modal>
    <register-model ref="registerModel" @login="login"></register-model>
    <div class="newProductsDialog">
      <!-- 弹窗 -->
      <el-dialog :visible.sync="dialogVisible" :before-close="handleClose" :close-on-click-modal="false" width="1200px">
        <div slot="title">
          <div
            class="product-details-title"
          >{{ $hs(`产品/${$hs(proInfo.pr_Na,proInfo.pr_En_Na,proInfo.basicThreeLanguage)}/产品详情`,`Product > ${$hs(proInfo.pr_Na,proInfo.pr_En_Na,proInfo.basicThreeLanguage)} > Product Details`,'') }}</div>
        </div>
        <div class="form-box">
          <div class="form-box-images">
            <img :src="proInfo.imgUrl" alt />
          </div>
          <div class="form-box-contents">
            <div class="pro-info">
              <div class="right-title">{{ $hs(proInfo.pr_Na,proInfo.pr_En_Na,proInfo.basicThreeLanguage) }}</div>
              <div class="label_No">
                <span>{{$hs('产品编号','Item NO.','Producto no.')}}：</span>
                <span style="color: #222222;">{{ proInfo.co_Nu }}</span>
              </div>

              <div class="label_prc">
                <span>{{$hs('产品价格','Price','Precio del producto')}}：</span>
                <span v-if="userInfo.status === 1" style="color: red;">
                  <span>{{ userInfo.symbol }}{{Number(proInfo.price)}}</span>
                </span>
                <span
                  v-else
                  style="color: #FF0000;font-size: 20px;cursor: pointer;"
                  @click="login"
                >{{ $hs('请登录','Please Login','Por favor inicie sesión') }}</span>
              </div>

              <div class="label_box">
                <div class="label_items">
                  <span class="label">{{$hs('包装方式','Packing','Forma de embalaje')}}：</span>
                  <span class="label_content">{{ $hs(proInfo.ch_Pa,proInfo.en_Pa,proInfo.packThreeLanguage) }}</span>
                </div>

                <div class="label_items">
                  <span class="label">{{$hs('外箱装量','Quantity:','Cantidad de carga en cartón externo')}}：</span>
                  <span class="label_content">{{ proInfo.ou_Lo || 0 }}(PCS)</span>
                </div>
              </div>

              <div class="label_box">
                <div class="label_items">
                  <span class="label">{{$hs('内盒个数','Inner Boxes','Número de cajas internas')}}：</span>
                  <span class="label_content">{{ proInfo.in_En || 0 }}</span>
                </div>
                <div class="label_items">
                  <span class="label">{{$hs('产品规格','Product Size','Especificaciones del producto')}}：</span>
                  <span class="label_content">{{ proInfo.pr_Le || 0 }} x {{ proInfo.pr_Wi || 0 }} x {{ proInfo.pr_Hi || 0 }}(CM)</span>
                </div>
              </div>

              <div class="label_box">
                <div class="label_items">
                  <span class="label">{{$hs('包装规格','Package Size','Especificación del paquete')}}：</span>
                  <span class="label_content">{{ proInfo.in_Le || 0 }} x {{ proInfo.in_Wi || 0 }} x {{ proInfo.in_Hi || 0 }}(CM)</span>
                </div>
                <div class="label_items">
                  <span class="label">{{$hs('外箱规格','Carton Size','Especificación del cartón exterior') }}：</span>
                  <span class="label_content">{{ proInfo.ou_Le || 0 }} x {{ proInfo.ou_Wi || 0 }} x {{ proInfo.ou_Hi || 0 }}(CM)</span>
                </div>
              </div>

              <div class="label_box">
                <div class="label_items">
                  <span class="label">{{$hs('毛重/净重','G.W/N.W','Volumen del cartón exterior')}}：</span>
                  <span class="label_content">{{ proInfo.gr_We || 0 }} / {{ proInfo.ne_We || 0 }}(KG)</span>
                </div>
                <div class="label_items">
                  <span class="label">{{$hs('体积/材积','CBM/Cuft','CBM')}}：</span>
                  <span class="label_content">{{ proInfo.bulk_Feet || 0.00}} /{{ proInfo.bulk_Stere || 0.00 }}</span>
                </div>
              </div>
              <div class="cart-box">
                <el-button
                  @click="click(proInfo,'')"
                  type="primary"
                  class="add-cart"
                >{{ ifAdd(proInfo.co_Nu) ? $hs('移除购物车','Remove from Cart','') : $hs('添加购物车','Add To Cart','') }}</el-button>
                <el-button @click="click(proInfo,'BuyNow')" type="primary" class="add-cart_now">{{$hs('立即购买','Buy Now','Comprar ahora')}}</el-button>
                <div class="add-videoLink" v-if="proInfo.other" @click="tiaozhaun(proInfo)">
                  <div>
                    <img src="../../assets/shiping.png" alt style="width: 32px;height: 32px;" />
                  </div>
                  <div>{{ $hs("视频链接","VIDEO LINK",'Enlace al video') }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer"></span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { addCartsApi, deletCartsApi } from '@/api/cart'
import { insertAddCart } from '@/api/statistics'
import loginModal from '@/components/memberModal/loginModal.vue'
import registerModel from '@/components/memberModal/registerModel.vue'
import { mapState, mapActions, mapGetters } from 'vuex'

export default {
  components: {
    loginModal,
    registerModel
  },
  data() {
    return {
      dialogVisible: false,
      proInfo: {}
    }
  },
  props: {
    productData: {
      type: Object,
      default: () => { }
    },
    types: {
      type: String,
      default: () => 'samll'
    }
  },
  computed: {
    // 用户信息
    ...mapState('user', ['userInfo']),
    // 语言
    ...mapState('operate', ['language']),
    ...mapGetters('operate', {
      gettingCart: 'getting_cart',
      getEnquiry: 'get_enquiry'
    }),
    // 标记购物车图标
    markCart() {
      return coNu => {
        // 购物车列表为空，直接返回标记
        return this.gettingCart.findIndex(item => item.co_Nu === coNu) > -1
      }
    },
    // 已加购还是取消加购
    ifAdd() {
      return coNu => {
        return this.gettingCart.findIndex(item => item.co_Nu === coNu) > -1
      }
    }
  },
  methods: {
    ...mapActions('operate', {
      addCart: 'add_cart',
      deleteCart: 'delete_cart',
      setEnquiry: 'set_enquiry'
    }),

    // 统计加购
    statisticsAddCart(data) {
      if (this.userInfo.id) {
        let obj = {
          mobile: this.userInfo.mobile || '',
          client_Na: this.userInfo.client_Na || '',
          userAccount: this.userInfo.userAccount || '',
          client_Nu: this.userInfo.client_Nu || '',
          pageUrl: this.$route.fullPath || '',
          pr_Na: data.pr_Na || '',
          co_Nu: data.co_Nu || '',
          fa_No: data.fa_No || '',
          ma_Na: data.ma_Na || '',
          ma_Nu: data.ma_Nu || ''
        }
        insertAddCart(obj).then(() => { })
      }
    },
    // 登录
    login() {
      this.$refs.loginModal.open()
    },
    fangdajin(productInfo) {
      this.proInfo = productInfo;
      this.dialogVisible = true;
    },
    // 注册
    register() {
      this.$refs.registerModel.open()
    },
    // 关闭视频
    handleClose(done) {
      done()
    },
    click(proInfo, Buytype) {
      if (!this.userInfo.id) {
        this.$refs.loginModal.open()
        return
      }
      if (!this.ifAdd(proInfo.co_Nu)) {
        // 添加商品
        if (this.userInfo) {
          addCartsApi({
            client_Nu: this.userInfo.client_Nu,
            userId: this.userInfo.id,
            co_Nu: proInfo.co_Nu,
            number: 1
          }).then(res => {
            if (res.success) {
              this.addCart({
                client_Nu: this.userInfo.client_Nu,
                userId: this.userInfo.id,
                co_Nu: proInfo.co_Nu,
                fa_No: proInfo.fa_No,
                imgUrl: proInfo.imgUrl,
                in_En: proInfo.in_En,
                number: 1,
                ou_Lo: proInfo.ou_Lo,
                pr_En_Na: proInfo.pr_En_Na,
                pr_Na: proInfo.pr_Na,
                price: proInfo.price,
                bulk_Stere: proInfo.bulk_Stere,
                bulk_Feet: proInfo.bulk_Feet,
                gr_We: proInfo.gr_We,
                ne_We: proInfo.ne_We,
                productRemark: proInfo.productRemark || ''
              })
              this.statisticsAddCart(proInfo)
            }
          })
        }
      } else {
        // 删除商品
        if (this.userInfo) {
          deletCartsApi({
            userId: this.userInfo.id,
            coNus: [proInfo.co_Nu]
          }).then(res => {
            if (res.success) {
              this.deleteCart(proInfo.co_Nu)
            }
          })
        }
      }
      if (Buytype == 'BuyNow') {
        this.dialogVisible = false;
        this.$router.push({ path: '/cart' })
      }
    },
    goProduct(item) {
      this.$router.push({
        name: 'product',
        params: { maNu: item.ma_Nu }
      })
      this.$bus.$emit('maNuProduct', item.ma_Nu)
    },
    handleMsg() {
      let content = this.$hs(
        '我们的工作人员会尽快联系您并为您开通账户高级权限。',
        'Our staff will contact you as soon as possible and open your account with advanced permissions',
        'Nuestro personal se pondrá en contacto con usted lo antes posible y abrirá permisos avanzados de cuenta para usted.'
      )
      this.$alert(content, this.$t('GA.systemTip'), {
        confirmButtonText: this.$t('GA.confirm'),
        callback: action => { }
      })
    },
    tiaozhaun(product) {
      window.open(product.other, '_blank');
    },
    gotoDetail(co_Nu) {
      this.$router.push({ 'path': '/proDetail', query: { coNu: co_Nu } })
      this.$emit('goto')
    },
    // 添加到购物车
    handleToCart(item) {
      if (!this.userInfo.id) {
        this.register()
        return
      }
      // 必须登陆后才能添加购物车
      if (Object.keys(this.userInfo).length === 0) {
        this.$message({
          message: this.$t('noLogin'),
          type: 'warning'
        })
        return
      }
      if (this.markCart(item.co_Nu)) {
        deletCartsApi({
          userId: this.userInfo.id,
          coNus: [item.co_Nu]
        }).then(res => {
          if (res.success) {
            this.deleteCart(item.co_Nu)
          }
        })
      } else {
        addCartsApi({
          client_Nu: this.userInfo.client_Nu,
          userId: this.userInfo.id,
          co_Nu: item.co_Nu,
          number: 1
        }).then(res => {
          if (res.success) {
            this.addCart({
              client_Nu: this.userInfo.client_Nu,
              userId: this.userInfo.id,
              co_Nu: item.co_Nu,
              fa_No: item.fa_No,
              imgUrl: item.imgUrl,
              in_En: item.in_En,
              number: 1,
              ou_Lo: item.ou_Lo,
              pr_En_Na: item.pr_En_Na,
              pr_Na: item.pr_Na,
              price: item.price,
              bulk_Stere: item.bulk_Stere
            })
            this.statisticsAddCart(item)
          }
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.product-details-title {
  font-size: 16px;
  font-weight: 400;
  color: #222222;
}
.newProductsDialog {
  :deep(.el-dialog__body) {
    padding: 0 !important;
    background: #fff !important;
    .form-box {
      margin-top: 20px;
      margin-bottom: 30px;
      display: flex;
      justify-content: center;
      width: 100%;
      .form-box-images {
        width: 560px;
        height: 480px;
        background: #ffffff;
        border: 1px solid #e5e5e5;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          max-width: 560px;
          max-height: 420px;
        }
      }
      .form-box-contents {
        margin-left: 30px;
        .pro-info {
          background-color: #fff;
          color: #333;
          min-height: 480px;
          .right-title {
            font-size: 20px;
            min-height: 26px;
            max-height: 100px;
            width: 500px;
            font-weight: 700;
            color: #222222;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            overflow: hidden;
          }
          .label_box {
            display: flex;
            align-items: center;
            height: 65px;
            flex: 1;
            width: 100%;
            border-bottom: 1px solid #f2f2f2;
            .label_items:nth-child(2n) {
              width: 45%;
            }
          }

          .cart-box {
            margin: 20px 0 0 0;
            display: flex;
            .add-cart {
              height: 42px;
              background: #ff0000;
              border: 1px solid #ff0000;
              font-size: 16px;
              font-weight: 700;
              border-radius: 3px !important;
            }
            .add-cart_now {
              height: 42px;
              border: 1px solid #ff0000;
              background: #ffffff;
              font-size: 16px;
              font-weight: 700;
              color: #ff0000;
              border-radius: 3px !important;
            }
            .add-videoLink {
              width: 170px;
              height: 42px;
              display: flex;
              align-items: center;
              justify-content: center;
              background: #ffffff;
              border: 1px solid #fe7415;
              color: #fe7415;
              font-size: 16px;
              font-weight: 700;
              margin-left: 10px;
              border-radius: 3px;
              cursor: pointer;
              img {
                margin-top: 8px;
                margin-right: 5px;
              }
            }
          }

          .label_items {
            display: flex;
            align-items: flex-start;
            width: 55%;
          }
          .label_items_right {
            display: flex;
            align-items: center;
          }
          .label_prc {
            color: #999999;
            margin: 32px 0 26px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            -o-text-overflow: ellipsis;
          }
          .label_No {
            display: inline-block;
            color: #999999;
            margin-top: 26px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            -o-text-overflow: ellipsis;
            font-size: 14px;
          }
          .label {
            display: inline-block;
            color: #999999;
            width: 100px;
            height: 30px;
            line-height: 30px;
            font-size: 14px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            -o-text-overflow: ellipsis;
            font-size: 14px;
          }
          .label_content {
            width: 170px;
            flex: 1;
            height: 30px;
            line-height: 30px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            -o-text-overflow: ellipsis;
            font-size: 14px;
            font-weight: 400;
            color: #222222;
          }
        }
      }
    }
  }
}

.item {
  height: 100%;
  box-sizing: border-box;
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  overflow: hidden;
  .img-box {
    height: 130px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: 1px solid #f8f8f8;
    box-sizing: border-box;
    cursor: pointer;
    overflow: hidden;

    img {
      max-width: 160px;
      max-height: 130px;
      object-fit: cover;
      // transition-duration: 0.5s;

      // &:hover {
      //   transition-duration: 0.5s;
      //   transform: scale(1.2);
      // }
    }
  }
  .bigsamll {
    height: 160px !important;
    img {
      max-height: 160px !important;
      width: 100%;
    }
  }

  .item-info {
    padding: 0px 10px 10px;
    box-sizing: border-box;
    .preices-serchart {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      margin-top: 14px;
      .price {
        font-size: 16px;
        font-weight: 700;
        text-align: left;
        color: #ff0000;
        line-height: 33px;
        cursor: pointer;
      }
      img {
        width: 24px;
        height: 24px;
        cursor: pointer;
      }
    }
    .title {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      font-size: 16px;
      font-weight: 400;
      height: 20px;
      color: #222222;
    }
    .num {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      margin: 6px 0;
      font-size: 14px;
      font-weight: 400;
      text-align: left;
      color: #999999;
    }

    .category {
      height: 16px;
      font-size: 12px;
      color: #999999;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    .date {
      margin: 10px 0 0 0;
      font-size: 12px;
      color: #666666;
      white-space: nowrap; /* 强制不换行 */
      overflow: hidden; /* 超出部分隐藏 */
      text-overflow: ellipsis; /* 显示省略号 */
    }

    .price-cart {
      width: 101px;
      height: 30px;
      border: 1px solid #e5e5e5;
      margin-top: 12px !important;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #f2410f;
      margin: 7px 0 7px;
      cursor: pointer;
      border-radius: 4px;
      i {
        font-weight: bold;
        font-size: 15px;
        color: rgba(0, 0, 0, 0.4);
      }
      span {
        font-size: 12px;
        font-weight: 400;
        color: #161616;
        margin-left: 5px;
      }
    }

    .price-cart-Active {
      border: 1px solid #f89595;
    }

    .mfrs-btn {
      height: 36px;
      background: #ffffff;
      border: 1px solid #dfdfdf;
      border-radius: 4px;
      // margin: 10px 0 0 0;
      text-align: center;
      line-height: 34px;
      font-size: 14px;
      box-sizing: border-box;
      cursor: pointer;
      &:hover {
        background-color: #f4400f;
        color: #fff;
        span {
          margin: 0 0 0 6px;
          color: #fff;
        }
      }
      span {
        margin: 0 0 0 6px;
        color: #222222;
      }
    }
  }
}

.el-icon-shopping-cart-full {
  color: #f4400f;
}
</style>